import { Col, Row } from "react-bootstrap";
import MaterialIcon, { MtIcon } from "../material-icon/material-icon";
import styles from "./steps-number.module.scss";

export interface ISteps {
  id: number;
  stepIcon?: MtIcon;
  stepName: string;
}

interface IProps {
  steps: ISteps[];
  selectedStep: number;
  onStepClick?: (stepNumber: number) => void;
}

const StepsNumber = (props: IProps) => {
  const { steps, selectedStep, onStepClick } = props;
  return (
    <Row className="g-4">
      {steps.map((step, index) => (
        <Col
          key={index}
          className={`col-12 col-sm-auto ${
            selectedStep === step.id ? styles.selected : styles.unselected
          }`}
        >
          <Row
            className={`align-items-center justify-content-center ${
              onStepClick && selectedStep !== step.id ? `cursor-pointer` : ``
            }`}
            onClick={() => {
              if (onStepClick) {
                onStepClick(step.id);
              }
            }}
          >
            <Col className={`col-auto ${styles.stepBg} mx-2`}>
              <Row className="align-items-center">
                <Col className="col-auto pe-0">
                  <div className={step.stepIcon ? styles.icon : styles.circle}>
                    {step.stepIcon ? (
                      <MaterialIcon
                        icon={step.stepIcon}
                        size={15}
                        color={
                          selectedStep === step.id
                            ? `var(--color-receipt-icon)`
                            : `var(--color-text-color-3)`
                        }
                      />
                    ) : (
                      step.id
                    )}
                  </div>
                </Col>
                <Col
                  className={`${styles.stepName} col-auto font-size-14 font-weight-600 ps-2`}
                >
                  {step.stepName}
                </Col>
              </Row>
            </Col>
            {index !== steps.length - 1 ? (
              <Col
                className={`${styles.dash} col-auto d-none d-sm-block`}
              ></Col>
            ) : (
              ``
            )}
          </Row>
        </Col>
      ))}
    </Row>
  );
};

export default StepsNumber;
